import { useState } from "react";
import { Share2, Copy, Check, MessageCircle } from "lucide-react";
import { toast } from "sonner";

/** Share controls for an owner web-site: native share, copy link, WhatsApp. */
export default function ShareButtons({ url, title = "Web-Site AVASA", compact = false }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Gagal menyalin tautan.");
    }
  };

  const native = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch { /* cancelled */ }
    } else {
      copy();
    }
  };

  const waUrl = `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`;
  const btn = "inline-flex items-center gap-2 rounded-full font-semibold transition-colors";
  const size = compact ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm";

  return (
    <div className="flex flex-wrap gap-2" data-testid="share-buttons">
      <button onClick={native} data-testid="share-native"
        className={`${btn} ${size} bg-primary text-primary-foreground hover:opacity-90`}>
        <Share2 size={compact ? 13 : 15} /> Bagikan
      </button>
      <button onClick={copy} data-testid="share-copy"
        className={`${btn} ${size} border border-border hover:bg-secondary/60`}>
        {copied ? <Check size={compact ? 13 : 15} className="text-emerald-600" /> : <Copy size={compact ? 13 : 15} />}
        {copied ? "Tersalin" : "Salin Link"}
      </button>
      <a href={waUrl} target="_blank" rel="noreferrer" data-testid="share-whatsapp"
        className={`${btn} ${size} border border-emerald-200 text-emerald-700 hover:bg-emerald-50`}>
        <MessageCircle size={compact ? 13 : 15} /> WhatsApp
      </a>
    </div>
  );
}
